import api from "@/api";
import PaymentData from "@/types/PaymentData";
import CheckoutResult from "../../types/CheckoutResult";
import { AxiosResponse } from "axios";
import PaymentMethod from "@/types/PaymentMethod";
import Order from "@/types/Order";

export default async function payOrder(
  order: Order,
  data: PaymentData,
  method: PaymentMethod,
): Promise<CheckoutResult> {
  const payload: PaymentData = JSON.parse(JSON.stringify(data)) as PaymentData;

  const response: AxiosResponse<CheckoutResult> = await api.post(`/api/checkout/pay`, {
    ...payload,
    method,
    order,
  });

  return response.data;
}
